import { IndentValues } from "@/lib/utils/IndentValues";
import { Indent, Txt } from "@stenajs-webui/core";
import { Icon, stenaExclamationTriangle } from "@stenajs-webui/elements";
import { Tooltip } from "@stenajs-webui/tooltip";
import { isSuggestedOnSameTargetAsExpected } from "../../lib/progressiveRebateValidation";
import { RebateProgress } from "@/gql/graphql";

interface Props {
  rebateProgress: RebateProgress;
}

export const RebateCompletionCell = ({ rebateProgress }: Props) => {
  const showDifferentTargetWarning = !isSuggestedOnSameTargetAsExpected(
    rebateProgress.displayedTarget,
    rebateProgress.expectedVolume ?? 0,
    rebateProgress.suggestedExpectedVolume
  );

  const targets = rebateProgress.displayedTarget.split("/");
  const showCompletedInsteadOfActual =
    targets.length === 1 &&
    Number.parseInt(targets[0]) <= 1 &&
    rebateProgress.achieved > 0;
  const displayValue = showCompletedInsteadOfActual
    ? "Completed"
    : `${rebateProgress.completionPercent} %`;

  return (
    <Indent flexDirection="row" gap={IndentValues.EIGHT} alignItems="center">
      <Txt>{displayValue}</Txt>
      {showDifferentTargetWarning && (
        <Tooltip label="Expected and Suggested have different targets">
          <Icon icon={stenaExclamationTriangle} />
        </Tooltip>
      )}
    </Indent>
  );
};
